module.exports = __webpack_public_path__ + "img/125.356dbbd7.jpg";